module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_wakhloo_sm-f1c9374e16d75ccf0b933813eb53dc78.png";